module.exports = __webpack_public_path__ + "img/newsCategories.e7108f59.svg";